// Module
var code = "<div class=\"hbox hbox-auto-xs hbox-auto-sm bg-light\">\n\n    <div ui-view=\"wideColumnView\"></div>\n\n</div>";
// Exports
module.exports = code;